import React from "react";
import { colors, space, radius, fontSize } from "../../design/tokens";

const variants = {
  success: {
    bg: colors.success,
    color: colors.text,
  },
  warning: {
    bg: colors.warning,
    color: colors.text,
  },
  error: {
    bg: colors.danger,
    color: colors.text,
  },
  info: {
    bg: colors.primary,
    color: colors.text,
  },
};

export default function Alert({
  severity = "info",
  children,
  style = {},
}) {
  const variant = variants[severity] || variants.info;

  return (
    <div
      style={{
        padding: `${space.md} ${space.lg}`,
        borderRadius: radius.md,
        background: variant.bg,
        color: variant.color,
        fontSize: fontSize.sm,
        display: "flex",
        alignItems: "center",
        gap: space.sm,
        ...style,
      }}
    >
      {children}
    </div>
  );
}